import { computed, type ComputedRef } from 'vue'

import { canWith } from '@/app/acl/can'
import { getConfig } from '@/app/config'
import { collectNav, filterNav, type NavItem } from '@/app/nav/collect'
import { useAuthStore } from '@/app/stores/auth'
import { useCurrentSoftware } from '@/shared/composables/useCurrentSoftware'

/** The modules' nav catalogue is static: collected once, for every caller. */
let catalogue: NavItem[] | undefined

/**
 * The current software's menu filtered for the user: what the vertical nav lists, and what the navbar's search
 * palette and alerts tray read, so the three never disagree.
 */
export function useShellMenu(): ComputedRef<NavItem[]> {
  const auth = useAuthStore()
  const config = getConfig()
  const { software } = useCurrentSoftware()
  const items = (catalogue ??= collectNav())
  return computed(() =>
    filterNav(items, {
      software: software.value,
      session: auth.session,
      betaFeature: config.betaFeature,
      can: (resource, action) => canWith(auth.session, resource, action),
    }),
  )
}
